<template>
  <div class="fullpage">
    <div class="fp-item fubg1">
      <div class="fp-item-cont">
        <div class="slogan">
          <h3>大象科技</h3>
          <span>数字化仿真系统和服务供应商</span>
        </div>
      </div>
    </div>
    <div class="fp-item fubg2">
      <div class="fp-item-cont">
        <div class="fenleititle" style="visibility: hidden">公司简介</div>
      <div class="gy_content">
        <div class="aboutus" style="visibility: hidden">
          <p class="article">北京大象科技有限公司成立于2013年，是国家高新技术企业、国家级专精特新"小巨人"企业。大象科技拥有交通运输部职业建设联系点、教育部双师型教师培训基地、北京市丰台区职业技能培训学院实训基地等资质。</p>
          <p class="article">公司业务范围包括轨道交通、低空技术、应急安全等领域。通过数字化沉浸式解决方案赋能轨道、应急、低空用户的技术验证、场景推演与人才培养，提升行业安全及效率。</p>
          <p class="article">公司拥有一支团结、奋进、精研的高水平技术团队作为整个公司技术创新的强力引擎，承担复杂技术难题攻关任务，持续输出高品质技术成果。获得多个科学进步奖。</p>
          
        </div>
      </div>
      </div>
    </div>
    <div class="fp-item fubg3">
      <div class="fp-item-cont">
        <div class="fenleititle" style="visibility: hidden">公司资质</div>
        <el-carousel class="carousel1" indicator-position="outside" height="380px" :autoplay=false>
          <el-carousel-item>
            <div class="certificate" style="visibility: hidden">
              <div class="detailpic">
                <img src="@/assets/home/grade/gaoxin.png"/>
                <span>高新技术企业证书</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/grade/xiaojuren.png"/>
                <span>国家级专精特新"小巨人"企业</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/grade/yidengjiang.png"/>
                <span>城市轨道交通科学进步一等奖</span>
                <!-- 城市轨道交通科学进步一等奖（大象）（基于异构云的城轨列控通用集成测试平台关键技术研究与应用） -->
              </div>
              <div class="detailpic">
                <img src="@/assets/home/grade/kexue.png"/>
                <span>北京市轨道交通学会科学技术进步奖二等奖</span>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="certificate_mobile">
          <div class="detailpic">
              <img src="@/assets/home/grade/gaoxin.png"/>
              <span>高新技术企业证书</span>
            </div>
            <div class="detailpic">
              <img src="@/assets/home/grade/xiaojuren.png"/>
              <span>国家级专精特新"小巨人"企业</span>
            </div>
            <div class="detailpic">
              <img src="@/assets/home/grade/yidengjiang.png"/>
              <span>城市轨道交通科学进步一等奖</span>
              <!-- 城市轨道交通科学进步一等奖（大象）（基于异构云的城轨列控通用集成测试平台关键技术研究与应用） -->
            </div>
            <div class="detailpic">
              <img src="@/assets/home/grade/kexue.png"/>
              <span>北京市轨道交通学会科学技术进步奖二等奖</span>
            </div>
        </div>
        <!-- 证书 -->
        <el-carousel  class="carousel2" indicator-position="outside" height="300px" :autoplay=false>
          <el-carousel-item>
            <div class="certificate2" style="visibility: hidden">
              <div class="detailpic">
                <img src="@/assets/home/zs/lianxidian.png"/>
                <span>交通运输部职业建设联系点</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/zs/shuangshi.png"/>
                <span>教育部双师型教师培训基地</span>
              </div>
              <div class="detailpic">
                <img src="@/assets/home/zs/shixunjidi.png"/>
                <span>北京市丰台区职业技能培训学院实训基地</span>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="certificate_mobile" style="margin-top: 50px;">
          <div class="detailpic">
            <img src="@/assets/home/zs/lianxidian.png"/>
            <span>交通运输部职业建设联系点</span>
          </div>
          <div class="detailpic">
            <img src="@/assets/home/zs/shuangshi.png"/>
            <span>教育部双师型教师培训基地</span>
          </div>
          <div class="detailpic">
            <img src="@/assets/home/zs/shixunjidi.png"/>
            <span>北京市丰台区职业技能培训学院实训基地</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import { useHead } from '@vueuse/head'
useHead({
      title: '北京大象科技有限公司官网',
      meta: [
        { name: 'description', content: '北京大象科技有限公司成立于2013年，业务范围包括轨道交通、低空技术、应急安全等领域。通过数字化沉浸式解决方案赋能轨道、应急、低空用户的技术验证、场景推演与人才培养，提升行业安全及效率'},
        { name: 'keywords', content:"轨道运营、地铁、低空、应急、培训、竞赛、实训基地、北京大象、大象科技、北京大象科技有限公司、北京大象科技有限公司官网"}
      ]
    })
    // const optionList = [
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    //   {label:'',value:'@/assets/home/诚信经营示范等级证书.png'}
    // ]
    onMounted(()=>{
      var element = document.getElementById('myElement');
      element.scrollTop = 0;
    })
</script>
<style lang="less" scoped>

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.slogan{
  margin-top: 30vh;
  // margin-left: 20%;
  opacity: 0; /* 初始透明度为0 */
  transform: translateY(100%); /* 初始位置在屏幕下方 */
  animation: slideUp 1.5s ease forwards; /* 应用动画并保持在结束状态 */
  h3{
    color:#fff;
    font-size: 88px;
    text-shadow: 0px 8px 8px rgba(0,0,0,0.5);
    margin:0;
  }
  span{
    color:#fff;
    font-size: 50px;
    text-shadow: 0px 8px 8px rgba(0,0,0,0.5);
    margin-top: 20px;
    display:block;
  }
    
}
.fullpage{
  width: 100%;
  height: 100%;
  .fp-item{
    width: 100%;
    .fp-item-cont{
      width:1200px;
      margin:0 auto;
      left:50%;
      margin-left:-600px;
      float:left;
      position: relative;
      margin-bottom: 50px;
    }
  }
  .fubg1{
    width:100%;
    height:100vh;
    background: url("@/assets/home_bg.jpg") no-repeat;
    background-size: cover;
    overflow-y: hidden;
  }
  .fubg2{
    width:100%;
    min-height:100vh;
    background: url("@/assets/content_bg.png") no-repeat;
    background-size: cover;
    overflow-y: hidden;
    .fenleititle{
      margin-top:170px;
      margin-bottom: 100px;
    }
    .article{
      margin:50px auto;
    }
    .detailpic{
      text-align:center;
    }
  }
  .fubg3{
    width:100%;
    min-height:100vh;
    background: #fff;
    .fenleititle{
      margin-top:50px;
    }
    .carousel2{
      margin-top:50px;
    }
    :deep(.el-carousel__arrow--left){
      left:2px;
      color:#CD4A26;
    }
    :deep(.el-carousel__arrow--right){
      right:2px;
      color:#CD4A26;
    }
    .certificate{
      display:flex;
      justify-content: center;
      .detailpic{
        width:22%;
        background:#F7F7F7;
        text-align:center;
        padding:15px 0;
        margin: 0 10px;
        img{
          width:85%;
        }
        span{
          display:block;
          margin-top:5px;
        }
      }
    }
    .certificate2{
      display:flex;
      justify-content: center;
      .detailpic{
        width:30%;
        background:#F7F7F7;
        text-align:center;
        padding:15px 0;
        margin: 0 10px;
        img{
          width:90%;
        }
        span{
          display:block;
          margin-top:5px;
        }
      }
    }
    :deep(.el-carousel__indicators--outside){
      button{
        background-color:#CD4A26 !important;
      }
      
    }
  }
  
}
.detailpic img{
    transition: transform 0.5s ease;
}
.detailpic img:hover{
    transform: scale(1.08);
}
// 平板样式
@media (max-width: 1200px) {
  .fullpage{
    .fenleititle:before {
      content: '';
      width: 50px;
      height: 3px;
      background: #CD4A26;
      position: absolute;
      margin-left: -120px;
      margin-top: 24px;
    }
    .fenleititle:after {
        content: '';
        width: 50px;
        height: 3px;
        background: #CD4A26;
        position: absolute;
        margin-top: 24px;
        margin-left: 70px;
    }
    .fubg2{
      height:auto !important;
      .fenleititle{
        margin-top:50px;
        margin-bottom:50px;
      }
      .article{
        margin: 20px auto;
      }
    }
    .fubg3{
      height:auto !important;
    }
    .fp-item-cont{
      width: 92% !important;
      margin: 0 4% !important;
      left: 0 !important;
      float: left !important;
      position: relative !important;
      .detailpic{
        width:100%;
        img{
          width:100%;
        }
      }
    }
  }
}
</style>